module.exports = __webpack_public_path__ + "img/map-marker-round-trip.420159df.svg";